export default __webpack_public_path__ + "static/media/delete.06b207d2.svg";